import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Form, Button, Toast, } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import img12 from "../assets/bgimg.png";
import { verifyotp, verifyOtpAndSetPassword } from "../store/slices/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const maskPhone = (phone) => {
  if (!phone) return "";
  return `+91 ******${phone.slice(-2)}`;
};

const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  return `${name.slice(0, 2)}****@${domain}`;
};

export default function OtpVerify() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { loading, error, user } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();
  const {
    email,
    phone,
    type = "register",
  } = location.state || {};

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "danger",
  });

  const inputRefs = useRef([]);

  /* Timer */
  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  /* OTP change + auto submit */
  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }


  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const verifyOtpHandler = async (autoOtp) => {
    const enteredOtp = autoOtp || otp.join("");

    if (enteredOtp.length !== 6) {
      setToast({
        show: true,
        message: "Please enter complete OTP",
        bg: "danger",
      });
      return;
    }

    let result;

    // Registration Flow
    if (type === "register") {
      result = await dispatch(
        verifyotp({
          email,
          emailOtp: enteredOtp,
        })
      );

      if (verifyotp.fulfilled.match(result)) {
        setToast({
          show: true,
          message: "OTP verified successfully",
          bg: "success",
        });

        setTimeout(() => {
          navigate("/admin/home", {
            replace: true,
          });
        }, 800);
      } else {
        setToast({
          show: true,
          message:
            result.payload?.message ||
            result.payload ||
            "Invalid OTP",
          bg: "danger",
        });
      }
    }

    // Forgot Password Flow
    else if (type === "forgotPassword") {
      if (!newPassword.trim()) {
        setToast({
          show: true,
          message: "Please enter new password",
          bg: "danger",
        });
        return;
      }

      result = await dispatch(
        verifyOtpAndSetPassword({
          email,
          mobileNumber: phone,
          otp: enteredOtp,
          newPassword,
        })
      );

      if (verifyOtpAndSetPassword.fulfilled.match(result)) {
        setToast({
          show: true,
          message: "Password reset successfully",
          bg: "success",
        });

        setTimeout(() => {
          navigate("/login", {
            replace: true,
          });
        }, 1000);
      } else {
        setToast({
          show: true,
          message:
            result.payload?.message ||
            result.payload ||
            "Failed to reset password",
          bg: "danger",
        });
      }
    }
  };


  const isOtpComplete = otp.every((digit) => digit !== "");

  return (
    <>
      {/* Toast */}
      <Toast
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        delay={3000}
        autohide
        bg={toast.bg}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 2000 }}
      >
        <Toast.Body className="text-white">
          {toast.message}
        </Toast.Body>
      </Toast>

      {/* Background */}
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${img12})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col xl={4} lg={5} md={6} sm={10} xs={12}>
                <Card className="shadow rounded-4">
                  <Card.Body className="p-4">
                    <h4 className="fw-bold text-center mb-2">
                      OTP Verification
                    </h4>

                    <p className="text-muted text-center mb-4">
                      Enter the 6-digit OTP sent to <br />
                      <strong>
                        {phone ? maskPhone(phone) : maskEmail(email)}
                      </strong>
                    </p>


                    <Row className="g-2 justify-content-center mb-3">
                      {otp.map((digit, index) => (
                        <Col xs={2} key={index}>
                          <Form.Control
                            ref={(el) =>
                              (inputRefs.current[index] = el)
                            }
                            value={digit}
                            onChange={(e) =>
                              handleChange(e.target.value, index)
                            }
                            onKeyDown={(e) =>
                              handleKeyDown(e, index)
                            }
                            maxLength={1}
                            className="text-center fw-semibold"
                            style={{
                              height: "48px",
                              fontSize: "18px",
                              boxShadow:
                                "0 0 8px rgba(42,143,158,0.6)",
                            }}
                          />
                        </Col>
                      ))}
                      {type === "forgotPassword" && (
                        <Form.Group className="mb-3 mt-3">
                          <Form.Label>New Password</Form.Label>

                          <div className="position-relative">
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              placeholder="Enter new password"
                              maxLength={25}
                            />

                            <span
                              className="position-absolute top-50 end-0 translate-middle-y me-3"
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                          </div>
                        </Form.Group>
                      )}
                    </Row>


                    <Button
                      className="w-100" type="submit"
                      style={{
                        backgroundColor: "#1e0959",
                        border: "none",
                        borderRadius: "30px",
                        padding: "10px",
                      }}
                      disabled={!isOtpComplete || loading}
                      onClick={() => verifyOtpHandler()}
                    >
                      {loading ? "Verifying..." : "Verify OTP"}
                    </Button>


                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
